import React from 'react';
import './AppStoreBadges.css';

function AppStoreBadges({ size = 'normal' }) {
  return (
    <div className={`app-store-badges ${size}`}>
      <a
        href="https://apps.apple.com/us/app/audra-books/id6756032522"
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge apple"
        aria-label="Download on the App Store"
      >
        <img
          src="/images/badges/app-store-badge.svg"
          alt="Download on the App Store"
          className="badge-img"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.randallresort.audra"
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge google"
        aria-label="Get it on Google Play"
      >
        <img
          src="/images/badges/google-play-badge.png"
          alt="Get it on Google Play"
          className="badge-img"
        />
      </a>
    </div>
  );
}

export default AppStoreBadges;
